import React, { useState, useEffect } from "react";
import styled from "styled-components";

const SliderContainer = styled.svg`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vmin; /* ビューポートの短辺を基準にする */
  height: 100vmin; /* ビューポートの短辺を基準にする */
  z-index: 10001;
  pointer-events:none;
  user-select: auto; /* テキスト選択を無効化 */
`;

const SliderPath = styled.path`
  fill: none;
  stroke: #fff;
  stroke-width: 0.1;
  pointer-events: none; /* パスはクリック不可 */
`;

const SliderThumb = ({ cx, cy, onMouseDown }) => (
  <>

    {/* 当たり判定を広げるための透明な円を先に描画 */}
    <circle
      cx={cx}
      cy={cy}
      r="4"                 // クリック領域を大きくしたい分、半径を大きめに
      fill="transparent"      // 色を付けない（透明）
      cursor="pointer"
      pointerEvents="auto"    // イベント取得を有効にする
      onMouseDown={onMouseDown}
    />

    {/* 外側の白い円 */}
    <circle
      cx={cx}
      cy={cy}
      r="0.9"
      fill="white"
      cursor="pointer"
      pointerEvents="auto"
      onMouseDown={onMouseDown}
    />
    {/* 内側の黒い円 */}
    <circle
      cx={cx}
      cy={cy}
      r="0.5"
      fill="black"
      cursor="pointer"
      pointerEvents="auto"
      onMouseDown={onMouseDown}
    />
  </>
);


const SliderText = styled.text`
  fill: #fff;
 font-size: ${({ fontSize }) => fontSize}px; /* フォントサイズを動的に設定 */
 font-family: "Nanum Myeongjo", serif; /* フォントを設定 */
  pointer-events: none; /* テキスト選択を無効化 */
`;




const MultiCircularSlider = ({ sliders, onValueChange }) => {
  const [sliderData, setSliderData] = useState([]);

  useEffect(() => {
    // 各スライダーのパスと初期位置を計算
    const updatedSliders = sliders.map((slider) => {

      const isCustomMapping = slider.option ?? false; // 未定義の場合は false
      const initialAngle = isCustomMapping
        ? mapValueToAnglee_unequal(
            slider.initialValue,
            slider.startAngle,
            slider.endAngle,
            slider.minValue,
            slider.maxValue
          )
        : mapValueToAngle(
            slider.initialValue,
            slider.startAngle,
            slider.endAngle,
            slider.minValue,
            slider.maxValue
          );


      const shortEdge = Math.min(
        document.documentElement.clientWidth,
        document.documentElement.clientHeight
      );
      const calculatedRadius = shortEdge * slider.radiusPercentage;
      const scaledRadius = (calculatedRadius / shortEdge) * 50;

      const startX =
        50 + scaledRadius * Math.cos((slider.startAngle * Math.PI) / 180);
      const startY =
        50 - scaledRadius * Math.sin((slider.startAngle * Math.PI) / 180);
      const endX =
        50 + scaledRadius * Math.cos((slider.endAngle * Math.PI) / 180);
      const endY =
        50 - scaledRadius * Math.sin((slider.endAngle * Math.PI) / 180);

      const largeArcFlag =
        slider.endAngle - slider.startAngle > 180 ? 1 : 0;
      const sweepFlag = 0;

      const path = `
        M ${startX},${startY}
        A ${scaledRadius},${scaledRadius} 0 ${largeArcFlag},${sweepFlag} ${endX},${endY}
      `;

      const thumbX =
        50 +
        scaledRadius * Math.cos((initialAngle * Math.PI) / 180);
      const thumbY =
        50 -
        scaledRadius * Math.sin((initialAngle * Math.PI) / 180);

     // フォントサイズをスライダーの半径に基づいて計算
     const fontSize = scaledRadius * 0.08; // 半径の10%をフォントサイズに設定

      return {
        ...slider,
        path,
        thumbX,
        thumbY,
        radius: scaledRadius,
        startX,
        startY,
        endX,
        endY,
        name:slider.name,
        min:slider.min,
        max:slider.max,
        fontSize,
        textPosition:slider.textPosition,
        angle: initialAngle,
        option:slider.option
      };
    });

    setSliderData(updatedSliders);
  }, [sliders]);

  // 角度を値に変換 等分割
const mapAngleToValue = (angle, startAngle, endAngle, minValue, maxValue) => {
  const normalizedAngle = (angle - startAngle) / (endAngle - startAngle);
  return Math.round(minValue + normalizedAngle * (maxValue - minValue));
};


// 値を角度に変換　等分割
const mapValueToAngle = (value, startAngle, endAngle, minValue, maxValue) => {
  const normalizedValue = (value - minValue) / (maxValue - minValue);
  return startAngle + normalizedValue * (endAngle - startAngle);
};

// 速度だけ特例で傾斜をつける
const mappingRules = [
  { startAngle: 230, endAngle: 265, minValue: 0, maxValue: 250 },
  { startAngle: 265, endAngle: 280, minValue: 250, maxValue: 3000 },
  { startAngle: 280, endAngle: 300, minValue: 3000, maxValue: 5000 },
];

// 角度を値に変換
const mapAngleToValue_unequal = (angle) => {
  for (const rule of mappingRules) {
    if (angle >= rule.startAngle && angle <= rule.endAngle) {
      const normalizedAngle = (angle - rule.startAngle) / (rule.endAngle - rule.startAngle);
      return rule.minValue + normalizedAngle * (rule.maxValue - rule.minValue);
    }
  }
  return null; // 範囲外の場合
};

// 値を角度に変換
const mapValueToAnglee_unequal = (value) => {
  for (const rule of mappingRules) {
    if (value >= rule.minValue && value <= rule.maxValue) {
      const normalizedValue = (value - rule.minValue) / (rule.maxValue - rule.minValue);
      return rule.startAngle + normalizedValue * (rule.endAngle - rule.startAngle);
    }
  }
  return null; // 範囲外の場合
};



  const handleDragStart = (e, sliderId) => {
    // テキスト選択を無効化
  document.body.style.userSelect = "none";
    const svgRect = e.target.ownerSVGElement.getBoundingClientRect();
    const centerX = svgRect.left + svgRect.width / 2;
    const centerY = svgRect.top + svgRect.height / 2;

    const handleMouseMove = (moveEvent) => {
      const dx = moveEvent.clientX - centerX;
      const dy = centerY - moveEvent.clientY;

      let newAngle = Math.atan2(dy, dx) * (180 / Math.PI);
      newAngle = (newAngle + 360) % 360;

      const slider = sliderData.find((s) => s.id === sliderId);
      if (!slider) return;

      if (newAngle < slider.startAngle || newAngle > slider.endAngle) {
        if (newAngle > slider.endAngle && newAngle < 360) {
          newAngle = slider.endAngle;
        } else {
          newAngle = slider.startAngle;
        }
      }

    // `newValue` を最初に定義
    let newValue;

    if (!slider.option) {
      newValue = mapAngleToValue(
        newAngle,
        slider.startAngle,
        slider.endAngle,
        slider.minValue,
        slider.maxValue
      );
    } else {
      newValue = mapAngleToValue_unequal(
        newAngle,
        slider.startAngle,
        slider.endAngle,
        slider.minValue,
        slider.maxValue
      );
    }


      const thumbX = 50 + slider.radius * Math.cos((newAngle * Math.PI) / 180);
      const thumbY = 50 - slider.radius * Math.sin((newAngle * Math.PI) / 180);

      setSliderData((prev) =>
        prev.map((s) =>
          s.id === sliderId ? { ...s, thumbX, thumbY, angle: newAngle } : s
        )
      );

      if (onValueChange) onValueChange(sliderId, newValue);
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <SliderContainer viewBox="0 0 100 100">
    

      {/* パスを描画 */}
      {sliderData.map((slider) => (
        <SliderPath key={`path-${slider.id}`} d={slider.path} />
      ))}



        {/* 開始点と終了点を描画 */}
        {sliderData.map((slider) => (
                <>
                <circle
                    key={`start-${slider.id}`}
                    cx={slider.startX}
                    cy={slider.startY}
                    r="0.5"
                    fill="#fff"
                />
                <circle
                    key={`end-${slider.id}`}
                    cx={slider.endX}
                    cy={slider.endY}
                    r="0.5"
                    fill="#fff"
                />
                </>
            ))}

      
          {/* スライダーの名称をパス上に描画 */}
    {sliderData.map((slider) => (
      <React.Fragment key={`name-${slider.id}`}>
        <defs>
          {/* パスの反転を適切に処理 */}
          <path
            id={`slider-path-${slider.id}`}
            d={slider.path}
      
          />
        </defs>
        <SliderText
          fontSize={slider.fontSize}
        dy="-0.5" /* 円の外側にオフセット (負の値で外側) */
        >
          <textPath
            href={`#slider-path-${slider.id}`}
            startOffset="50%" /* テキストを中央に配置 */
            textAnchor="middle" /* テキスト中央揃え */

          
          >
            {slider.name}
          </textPath>

        </SliderText>
        
        <SliderText
          fontSize={slider.fontSize*0.5}
        
        >
          <textPath
            href={`#slider-path-${slider.id}`}
            startOffset="98%" /* テキストを中央に配置 */
            textAnchor="end" /* テキスト中央揃え */
          
          >
            {slider.max}
          </textPath>

        </SliderText>

        <SliderText
          fontSize={slider.fontSize*0.5}
        
        >
          <textPath
            href={`#slider-path-${slider.id}`}
            startOffset="2%" /* テキストを中央に配置 */
            textAnchor="start" /* テキスト中央揃え */
          
          >
            {slider.min}
          </textPath>

        </SliderText>

          {/* 現在の値 */}

    <SliderText
      fontSize={slider.fontSize * 0.5}
      dy="2" /* 垂直方向の位置調整 */
    >
      <textPath
        href={`#slider-path-${slider.id}`}
        startOffset="75%" /* 現在の値をスライダーの75%地点に配置 */
        textAnchor="middle" /* 中央揃え */
       
      >
        {mapAngleToValue(
          slider.angle,
          slider.startAngle,
          slider.endAngle,
          slider.minValue,
          slider.maxValue
        )}
      </textPath>
    </SliderText>


      </React.Fragment>
    ))}


      {/* つまみを描画 */}
      {sliderData.map((slider) => (
        <SliderThumb
          key={`thumb-${slider.id}`}
          cx={slider.thumbX}
          cy={slider.thumbY}
          r="0.7"
          onMouseDown={(e) => handleDragStart(e, slider.id)}
        />
      ))}



    </SliderContainer>
  




);
};

export default MultiCircularSlider;
